<template>
  <a-table
    :columns="columns"
    :data-source="list"
    :pagination="false"
    bordered
  >
    <template slot="fixed" slot-scope="t">
      {{ t || t === 0 ? Number(t).toFixed(len || 0) : t }}
    </template>
    <a-tooltip slot="name" slot-scope="t">
      <template slot="title">
        {{ t }}
      </template>
      {{ t }}
    </a-tooltip>
    <a-tooltip slot="scanDetail" slot-scope="t,r">
      <template slot="title">
        {{ t }}
      </template>
      <a v-if="r.nhfFormulaId" @click="scanDetail(r)">{{ t }}</a>
      <span v-else>{{ t }}</span>
    </a-tooltip>
  </a-table>
</template>

<script>
export default {
  props: ['columns','list','len','url'],
  methods: {
    scanDetail(record){
      this.$router.push({
        path: this.url,
        query: {
          id: record.nhfFormulaId
        }
      })
    }
  }
}
</script>